import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { HOST } from "Constant/Constant";

export const invoiceApi = createApi({
  reducerPath: "invoiceApi",
  baseQuery: fetchBaseQuery({
    baseUrl: HOST,
  }),

  endpoints: (builder) => ({
    getInvoiceList: builder.query({
      query: ({ page, numOfRows }) => ({
        url: `/get-invoice?page=${page}&numOfRows=${numOfRows}`,
        method: "GET",
        headers: {
          authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }),
    }),

    updateInvoiceData: builder.mutation({
      query: ({ body }) => ({
        url: "/generateInvoice",
        method: "POST",
        body,
        headers: {
          authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "application/json",
        },
      }),
    }),

    InvoiceSend: builder.mutation({
      query: ({ body }) => ({
        url: "/invoice/send",
        method: "POST",
        body,
        headers: {
          authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "application/json",
        },
      }),
    }),
  }),
});

export const { useGetInvoiceListQuery, useUpdateInvoiceDataMutation, useInvoiceSendMutation } = invoiceApi;